import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCycleCodeList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceCycleCode: DataSource;
    tableCycleCode: Table;
}
